export const COLOR_PODUCTION_TYPE = 'aliceblue' as const
